import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'
import type { AccentVar } from './AccentContext'

export type LoadingButtonTone = 'primary' | 'disabled' | 'danger'

interface LoadingButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  tone?: LoadingButtonTone
  label: ReactNode
  meta?: ReactNode
  accent?: AccentVar
}

export function LoadingButton({
  tone = 'primary',
  label,
  meta,
  accent,
  className,
  style,
  disabled,
  ...rest
}: LoadingButtonProps) {
  const toneClass = tone === 'disabled' ? 'tone-disabled' : tone === 'danger' ? 'tone-danger' : null
  const accentStyle: CSSProperties | undefined =
    accent && tone === 'primary' ? { background: `var(${accent})` } : undefined
  const mergedStyle = accentStyle ? { ...accentStyle, ...style } : style
  const isDisabled = disabled ?? tone === 'disabled'

  return (
    <button
      type="button"
      className={cx('st-loading-btn', toneClass, className)}
      style={mergedStyle}
      disabled={isDisabled}
      aria-busy={true}
      {...rest}>
      <span className="st-loading-btn-dots" aria-hidden="true">
        <span className="bd" />
        <span className="bd" />
        <span className="bd" />
      </span>
      <span aria-live="polite">{label}</span>
      {meta != null && <span className="st-loading-btn-meta">{meta}</span>}
    </button>
  )
}
